// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list_2gyCd","selectedMenu":"List_selectedMenu_1-3tR"};